"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'voices.magdalena.description': '低音、温暖，具有平静力量和细腻感。',
};
